
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductDetail } from '@/types/product';

interface ProductState {
  currentProduct: ProductDetail | null;
  loading: boolean;
  error: string | null;
  trackingInProgress: boolean;
  blockedFeaturesMessage: string | null;
}

const initialState: ProductState = {
  currentProduct: null,
  loading: false,
  error: null,
  trackingInProgress: false,
  blockedFeaturesMessage: null,
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    fetchProductRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchProductSuccess: (state, action: PayloadAction<ProductDetail>) => {
      state.currentProduct = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchProductFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    trackProductRequest: (state, action: PayloadAction<string>) => {
      state.trackingInProgress = true;
    },
    trackProductSuccess: (state) => {
      state.trackingInProgress = false;
      if (state.currentProduct) {
        state.currentProduct.is_tracked = true;
      }
    },
    trackProductFailure: (state, action: PayloadAction<string>) => {
      state.trackingInProgress = false;
      state.error = action.payload;
    },
    setBlockedFeaturesMessage: (state, action: PayloadAction<string | null>) => {
      state.blockedFeaturesMessage = action.payload;
    },
  },
});

export const {
  fetchProductRequest,
  fetchProductSuccess,
  fetchProductFailure,
  trackProductRequest,
  trackProductSuccess,
  trackProductFailure,
  setBlockedFeaturesMessage
} = productSlice.actions;

export default productSlice.reducer;
